import { GA } from 'types';

export interface LogoutData {
  type: GA.EventType.LOGOUT;
  method: GA.AuthMethod;
}

export interface LogoutEvent {
  event: LogoutData['type'];
  event_data: {
    action: GA.Action.LOGOUT;
    method: GA.AuthMethod;
  };
}

const getLogoutEvent = (data: LogoutData): LogoutEvent => {
  const { type, method } = data;
  return {
    event: type,
    event_data: {
      action: GA.Action.LOGOUT,
      method,
    },
  };
};

export default getLogoutEvent;
